
import React from 'react';
import Select from 'react-select';
import { useIsMobile } from '@/hooks/use-mobile';
import { WorksheetOption } from './types';
import { customStyles } from '../../SelectStyles';
import WorksheetOptionLabel from './WorksheetOptionLabel';

interface WorksheetSelectorProps {
  options: WorksheetOption[];
  value: WorksheetOption | null;
  onChange: (option: WorksheetOption | null) => void;
  onInputChange: (inputValue: string) => void;
  isLoading: boolean;
  disabled: boolean;
}

const WorksheetSelector: React.FC<WorksheetSelectorProps> = ({
  options,
  value,
  onChange,
  onInputChange,
  isLoading,
  disabled
}) => {
  const isMobile = useIsMobile();

  // Format option label with status badge
  const formatOptionLabel = (option: WorksheetOption) => (
    <WorksheetOptionLabel option={option} />
  );

  return (
    <Select<WorksheetOption>
      options={options}
      value={value}
      onChange={onChange}
      onInputChange={onInputChange}
      isLoading={isLoading}
      isClearable={true}
      placeholder="ค้นหาเวิร์กชีท..."
      noOptionsMessage={() => "พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา"}
      styles={customStyles}
      formatOptionLabel={formatOptionLabel}
      className="react-select-container"
      classNamePrefix="react-select"
      menuPlacement={isMobile ? "auto" : "bottom"}
      menuPosition="fixed"
      isDisabled={disabled}
    />
  );
};

export default WorksheetSelector;
